import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle-group";
import { cn } from "@/lib";

const ToggleGroup = TogglePrimitive.Root;
const ToggleGroupItem = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Item>
>(({ className, ...props }, ref) => (
  <TogglePrimitive.Item
    ref={ref}
    className={cn(
      "px-3 py-1.5 text-sm rounded-md border data-[state=on]:bg-brand/90 data-[state=on]:text-white",
      "hover:bg-muted/40",
      className
    )}
    {...props}
  />
));
ToggleGroupItem.displayName = TogglePrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
